module.exports = __webpack_public_path__ + "img/Weapon_67.faef2156.png";